<template>
  <div class="mt-10">
    <el-transfer
      v-model="releaseReposID"
      :data="reposT"
      :titles="['待选', '选中']"
    >
    </el-transfer>
    <el-pagination
      :small="true"
      :current-page.sync="currentPage"
      :page-size="10"
      :total="paging.total"
      layout="prev,next,jumper"
    ></el-pagination>
  </div>
</template>

<script>
import { ReposListPagingMixin } from "@/mixins";
export default {
  name: "ReleaseReposAdminTransfer",
  props: {
    releaseRepos: {
      type: Array,
      default: () => []
    }
  },
  mixins: [ReposListPagingMixin],
  data() {
    return {
      currentPage: 1
    };
  },
  created() {
    this.listRepos();
  },
  watch: {
    currentPage() {
      this.listRepos();
    }
  },
  computed: {
    releaseReposID: {
      get: function() {
        return this.releaseRepos.map(repo => repo.id);
      },
      set: function(reposID) {
        this.$emit("change", reposID);
      }
    },
    reposT() {
      let releaseRepos = this.buildReposObjectList(this.releaseRepos);
      let reposSource = this.buildReposObjectList(this.repos);
      return this.mergeReposObjectList(releaseRepos, reposSource);
    }
  },
  methods: {
    buildReposObjectList(repos) {
      return repos.map(repo => {
        return {
          key: repo.id,
          label: `${repo.title}-${repo.version}`
        };
      });
    },
    mergeReposObjectList(r1, r2) {
      r2.map(rr => {
        let got = false;
        for (let s of r1) {
          if (rr.key === s.key) got = true;
        }
        if (!got) {
          r1.push(rr);
        }
      });
      return r1;
    },
    listRepos() {
      this.getReposList("/api/v1/repos", {
        page_size: 10,
        page: this.currentPage
      });
    }
  }
};
</script>

<style scoped lang="scss">
/deep/.el-transfer {
  display: grid;
  grid-template-columns: 1fr 100px 1fr;
}
/deep/.el-transfer-panel {
  width: 100%;
  position: unset;
}
/deep/.el-transfer-panel__body,
/deep/.el-transfer-panel__list {
  height: 315px;
}
/deep/.el-transfer__buttons {
  margin-top: 150%;
  transform: translate(-50% -50%);
}
</style>
